import { DockerSetupFormData, DockerSetupPolicyPayload } from './types';

/**
 * Builds the API payload from form data
 * Wraps values in Directive structure as expected by backend
 */
export function buildDockerSetupPayload(
  formData: DockerSetupFormData
): DockerSetupPolicyPayload {
  return {
    enableHostManagementFeatures: {
      value: formData.enableHostManagementFeatures,
      enforce: false,
    },
    allowVolumeBrowserForRegularUsers: {
      value: formData.allowVolumeBrowserForRegularUsers,
      enforce: false,
    },
    enableGpuManagement: {
      value: formData.enableGpuManagement,
      enforce: false,
    },
    enableImageNotification: {
      value: formData.enableImageNotification,
      enforce: false,
    },
    gpus: {
      value: formData.gpus,
      enforce: false,
    },
    endpointChangeWindow: {
      value: formData.changeWindow,
      enforce: false,
    },
  };
}
